var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradientUploadIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4391 16.3583V4.47833L6.95206 7.96533L5.46207 6.43134L11.5001 0.392334L17.5381 6.43036L16.0481 7.96436L12.5611 4.47736V16.3574L10.4391 16.3583ZM3.44907 21.6074C3.11207 21.6141 2.77723 21.5517 2.46525 21.4241C2.15326 21.2965 1.87073 21.1064 1.63506 20.8654C1.39406 20.6297 1.2039 20.3471 1.07629 20.0352C0.948671 19.7232 0.886321 19.3883 0.893074 19.0513V15.2163H3.01406V19.0513C3.01511 19.108 3.02772 19.1638 3.05111 19.2154C3.07449 19.267 3.10816 19.3132 3.15006 19.3513C3.18817 19.3932 3.23445 19.4269 3.28603 19.4503C3.33762 19.4737 3.39344 19.4863 3.45007 19.4873H19.5501C19.6067 19.4863 19.6625 19.4737 19.7141 19.4503C19.7657 19.4269 19.8119 19.3932 19.8501 19.3513C19.892 19.3132 19.9256 19.267 19.949 19.2154C19.9724 19.1638 19.985 19.108 19.9861 19.0513V15.2163H22.1071V19.0513C22.1138 19.3883 22.0515 19.7232 21.9239 20.0352C21.7962 20.3471 21.6061 20.6297 21.3651 20.8654C21.1294 21.1064 20.8469 21.2965 20.5349 21.4241C20.2229 21.5517 19.8881 21.6141 19.5511 21.6074H3.44907Z",
    fill: "url(#paint0_linear_57_175)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_175",
    x1: 0.892578,
    y1: 11.0001,
    x2: 22.1076,
    y2: 11.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52AE32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006535"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientUploadIcon);
export default __webpack_public_path__ + "static/media/gradient-upload-icon.0fd7aad970d43f973b1554688c8c95b5.svg";
export { ForwardRef as ReactComponent };